/**
 * Product Carousel - Horizontal scrolling product carousel
 * Desktop: Button-controlled carousel
 * Mobile: Native scroll
 */

(function() {
  'use strict';

  function initProductCarousel(carouselWrapper) {
    const carouselId = carouselWrapper.dataset.carouselId;
    const track = carouselWrapper.querySelector(`.product-carousel-track[data-carousel-id="${carouselId}"]`);
    const cards = track ? track.querySelectorAll('.product-carousel-card') : [];
    const prevBtn = carouselWrapper.querySelector(`.product-carousel-nav.prev[data-carousel-id="${carouselId}"]`);
    const nextBtn = carouselWrapper.querySelector(`.product-carousel-nav.next[data-carousel-id="${carouselId}"]`);
    const carousel = carouselWrapper.querySelector('.product-carousel');

    if (!track || !cards.length) return;

    // Check if mobile (992px breakpoint)
    function isMobile() {
      return window.innerWidth <= 992;
    }

    // Only run carousel logic on desktop
    if (!isMobile()) {
      let currentIndex = 0;
      const gap = 30;

      function calculateDimensions() {
        if (cards.length === 0) return { cardWidth: 0, cardsPerView: 0, maxIndex: 0 };
        
        const cardWidth = cards[0].offsetWidth;
        const carouselWidth = carousel.offsetWidth;
        const trackWidth = track.scrollWidth;
        const visibleWidth = carouselWidth;
        
        // Calculate how many cards fit in the visible area
        const cardsPerView = Math.floor((visibleWidth + gap) / (cardWidth + gap));
        
        // Calculate max index - stop when the last card is fully visible
        // We need to scroll until the last card's right edge aligns with the carousel's right edge
        const totalCards = cards.length;
        const maxIndex = Math.max(0, totalCards - cardsPerView);
        
        return { cardWidth, cardsPerView, maxIndex, trackWidth, visibleWidth };
      }

      function updateCarousel() {
        const { cardWidth, maxIndex } = calculateDimensions();
        
        // Calculate the exact offset needed
        const offset = currentIndex * (cardWidth + gap);
        track.style.transform = `translateX(-${offset}px)`;

        // Check if we've actually reached the end by comparing track position
        const trackRect = track.getBoundingClientRect();
        const carouselRect = carousel.getBoundingClientRect();
        const lastCard = cards[cards.length - 1];
        const lastCardRect = lastCard.getBoundingClientRect();
        
        // Check if last card is fully visible or past the visible area
        const isAtEnd = lastCardRect.right <= carouselRect.right + 5; // 5px tolerance
        
        // Update button states
        if (prevBtn) {
          prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
          prevBtn.disabled = currentIndex === 0;
        }
        if (nextBtn) {
          const shouldDisable = currentIndex >= maxIndex || isAtEnd;
          nextBtn.style.opacity = shouldDisable ? '0.5' : '1';
          nextBtn.disabled = shouldDisable;
        }
      }

      function canMoveNext() {
        const { maxIndex } = calculateDimensions();
        const trackRect = track.getBoundingClientRect();
        const carouselRect = carousel.getBoundingClientRect();
        const lastCard = cards[cards.length - 1];
        const lastCardRect = lastCard.getBoundingClientRect();
        
        // Can't move if we're at max index OR if last card is already visible
        return currentIndex < maxIndex && lastCardRect.right > carouselRect.right + 5;
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          if (canMoveNext()) {
            currentIndex++;
            updateCarousel();
          }
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          if (currentIndex > 0) {
            currentIndex--;
            updateCarousel();
          }
        });
      }

      // Handle window resize
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          if (!isMobile()) {
            const { maxIndex } = calculateDimensions();
            if (currentIndex > maxIndex) currentIndex = maxIndex;
            updateCarousel();
          } else {
            // Reset transform on mobile
            track.style.transform = 'none';
          }
        }, 250);
      });

      // Initialize
      updateCarousel();
    } else {
      // On mobile, ensure transform is reset and allow native scrolling
      track.style.transform = 'none';
    }
  }

  // Initialize all product carousels
  function initAllProductCarousels() {
    const carousels = document.querySelectorAll('.product-carousel-wrapper');
    carousels.forEach(carousel => {
      initProductCarousel(carousel);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductCarousels);
  } else {
    initAllProductCarousels();
  }

  // Re-initialize on Shopify section load
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const carousel = event.detail.querySelector('.product-carousel-wrapper');
      if (carousel) {
        initProductCarousel(carousel);
      }
    });
  }
})();
